import React, { memo, useCallback, useEffect, useState } from "react";
import { uploadFileToS3 } from "../../helper/utils";
import { useFetch } from "../../hooks/useFetch";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import _ from "lodash";
import DynamicButton from "../../component/button";
import BottomSheet from "./sheet";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AToggleLoding } from "../../store/reducer/settings";
import { useDispatch } from "react-redux";
import CustomModal from "../../component/modal/CustomModal";
function Salaryslip() {
  // Hooks
  const router = useNavigate();
  const dispatch = useDispatch();
  const [query] = useSearchParams();
  const [loader, setLoader] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<any>([]);
  const state = useSelector((state: RootState) => state.invitation.invitation);
  const [open, setOpen] = useState<boolean>(false);
  const [token, setToken] = useState<string>("");
  const [BankStatement, setBankStatement] = useState<any>([]);
  const [mounted, setMounted] = useState<boolean>(false);
  const [Tokenresponse, Setresponse] = useState<any>({});
  const [popInfoPopup, setpopInfoPopup] = useState<any>(false);

  useEffect(() => {
    if (!mounted) setMounted(true);
    return () => setMounted(false);
  }, []);
  useEffect(() => {
    if (mounted) {
      const token = query.get("token");
      console.log("token");

      if (token) setToken(token);
      else router("/invalid");
    }
  }, [mounted]);
  // Constant
  const uploadImage = async (filee: any) => {
    console.log("__filee", filee);
    if (filee) {
      dispatch(AToggleLoding());
      const { type: fileType, name: fileName } = filee;
      const type = "pdf";
      const { data }: any = await useFetch.get("medias/b2c-signed-url", {
        params: {
          requestType: "upload",
          b2cReqId: Tokenresponse.b2cReqId,

          cnic: Tokenresponse.cnic,
          scope: "any",
          fileName: `${Tokenresponse.cnic}_BankStatement.${type}`,
          fileType,
          folderName: "b2c",
          key: state?.key,
        },
      });
      const url = data?.data?.signedUrl;
      await uploadFileToS3(url, filee);
      const urlPath = data?.data?.urlPath;
      setBankStatement([...BankStatement, { urlPath }]);
      dispatch(AToggleLoding());
      console.log("__urlPath", urlPath);
      setOpen(true);
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(AToggleLoding());
      useFetch
        .post("b2c/fetch-token", {
          token,
        })
        .then((res) => {
          const { data } = res;
          console.log("_data", data);
          Setresponse(data.data || {});
          dispatch(AToggleLoding());
        })
        .catch(() => {
          dispatch(AToggleLoding());
          return router("/invalid");
        });
    }
  }, [token]);

  const handleNext = () => {
    setLoader(true);
    const updatedFileData = BankStatement.map((item: any) => {
      return {
        // companyName: Tokenresponse?.companies[0],
        mediaProof: item.urlPath,
      };
    });
    console.log("__BankStatement", updatedFileData);

    let body = {
      id: Tokenresponse.b2cReqId,
      step: 2,
      companyName: Tokenresponse.companies[0],
      info: {
        salarySlips: updatedFileData,
      },
    };
    return useFetch
      .post(`b2c/request/step`, {
        ...body,
      })
      .then((res: any) => {
        setLoader(false);
        console.log("updateB2CStep => ", res);
        router("?status=complete");
        return res?.data?.data?.id;
      })
      .catch((err) => {
        setLoader(false);
        console.log("ERROR", err?.response?.data);
        throw err;
      });
  };
  const validateData = (data: any) => {
    const isMediaproofMissing = data.some(
      (item: any) => !item.mediaproof || item.mediaproof === ""
    );

    return isMediaproofMissing;
  };
  console.log("__BankStatement", BankStatement);
  const ondelete = (index: number) => {
    setBankStatement((prev: any) =>
      prev.filter((_: any, i: any) => i !== index)
    );
  };
  console.log("__BankStatement,BankStatement", BankStatement);

  return (
    <>
      {popInfoPopup && (
        <CustomModal
          image={"./assets/OtherOption.png"}
          imgstyle={`h-[200px]`}
          paragraph={"Upload pdf of your salary slip"}
          onClose={function (): void {
            setpopInfoPopup(!popInfoPopup);
          }}
        />
      )}
      <div className="flex flex-col p-5 pt-10 justify-between h-[100vh] w-full overflow-x-hidden">
        <div>
          <div className="flex flex-col w-full items-center justify-center">
            <img src="/assets/uploadIcon.svg" alt="upload" />
            <h1 className="text-white text-center font-bold text-xl mt-3">
              Upload Salary Slip
            </h1>
            <p className="text-center text-white text-[15px] mt-4">
              To verify your work details, upload your recent salary slip
            </p>
          </div>
          <div>
            <div className="mt-6 flex-row  flex items-center">
              <h2 className="text-white text-[12px]">Salary slip* </h2>
              <button onClick={() => setpopInfoPopup(!popInfoPopup)}>
                <img
                  src="/assets/InfoIcon.png"
                  className="ml-2"
                  height={20}
                  width={20}
                  alt=""
                />
              </button>
            </div>

            <div>
              <input
                type="file"
                className="hidden"
                id={`bankfile1`}
                accept=".pdf"
                onChange={(e: any) => uploadImage(e?.target?.files[0])}
              />
              <div className="relative w-[70px]">
                {BankStatement[0]?.urlPath ? (
                  <button
                    onClick={() => ondelete(0)}
                    className="h-5 w-5 absolute bg-white rounded-xl flex items-center justify-center -top-2 -right-2"
                  >
                    <h1>X</h1>
                  </button>
                ) : null}

                <label htmlFor={`bankfile1`}>
                  <div className="flex mt-4 p-2 h-[70px] w-[70px] rounded-[5px] bg-[#172A46] items-center justify-center ">
                    {BankStatement[0]?.urlPath ? (
                      <img
                        src={"./assets/pdfIcon.png"}
                        className="w-full h-full"
                        alt="img"
                      />
                    ) : (
                      <h1 className="text-white text-[30px]">+</h1>
                    )}
                  </div>
                </label>
                <h2 className="text-[#C8D3F5] opacity-[0.5] text-[12px] font-bold mt-2 ml-1s">
                  Upload File
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="flex mt-10 w-full items-start justify-center">
          <DynamicButton
            isDisabled={BankStatement.length < 1}
            type="submit"
            isLoading={loader}
            onClick={handleNext}
          >
            CONFIRM
          </DynamicButton>
        </div>
      </div>
    </>
  );
}

export default memo(Salaryslip);
